import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { AlertFullWidth } from '@/lib/base/overlays/alerts';

export function OfflineIndicator() {
  const isOnline = useOnlineStatus();
  return (
    <div role='status' aria-live='polite' aria-atomic='true'>
      {!isOnline && (
        <AlertFullWidth
          title="You're offline"
          description='Changes may not be saved until your connection returns.'
          color='warning'
        />
      )}
    </div>
  );
}
